/**
 * @summary: This is where you import your dynamic modules so webpack can build chunks and load them asynchronously
 */
export const importMap = {
  // LookBuilder: {
  //   getComponent: () => import('./components/LookBuilder'),
  // },
  Releases: {
    getComponent: () => import('./components/Releases/Releases'),
  },
  SearchBar: {
    getComponent: () => import('./components/SearchBar/SearchBar'),
  },
  CollectionPage: {
    getComponent: () => import('./components/ProductListingPage/pages/CollectionPage'),
  },
  GlobalSearchPage: {
    getComponent: () => import('./components/ProductListingPage/pages/GlobalSearchPage'),
  },
  // StoreStockLoader: {
  //   getComponent: () => import('./components/StoreStockTable'),
  // },
  // FindInStore: {
  //   getComponent: () => import('./components/StoreStockTable'),
  // },
  MyAccount: {
    getComponent: () => import('./components/MyAccount'),
  },
  OrderDetails: {
    getComponent: () => import('./components/MyAccount'),
  },
  Colorways: {
    getComponent: () => import('./components/Colorways'),
  },
  PromotionBar: {
    getComponent: () => import('./components/PromotionBar'),
  },
  CartFreeGifts: {
    getComponent: () => import('./components/CartFreeGifts'),
  },
  Megamenu: {
    getComponent: () => import('./components/Megamenu'),
    isHydrate: true,
  },
  Mobilemenu: {
    getComponent: () => import('./components/Mobilemenu'),
    isHydrate: true
  },
  BundleListing: {
    getComponent: () => import('./components/BundleListing'),
  },
  NewsLetter: {
    getComponent: () => import('./components/NewsLetter'),
  },
  PopupSignUp: {
    getComponent: () => import('./components/NewsLetter/PopupSignUp'),
  },
  BYOBundlePage: {
    getComponent: () => import('./components/ProductListingPage/pages/BYOBundlePage'),
  },
  CuratedCollectionPage: {
    getComponent: () => import('./components/ProductListingPage/pages/CuratedCollectionPage'),
  },
  BogofCollectionPage: {
    getComponent: () => import('./components/ProductListingPage/pages/BogofCollectionPage'),
  },
  ProductPDPCalloutSash: {
    getComponent: () => import('./components/ProductSash'),
  },
  ProductTopSash: {
    getComponent: () => import('./components/ProductSash'),
  },
  Countdown: {
    getComponent: () => import('./components/Countdown'),
    eventListener: 'initCountDown'
  },
  CollectionListPage: {
    getComponent: () => import('./components/ProductListingPage/pages/CollectionListPage'),
  },
  ModalLink: {
    getComponent: () => import('./components/ModalLink'),
  },
  CollectionHeroImage: {
    getComponent: () => import('./components/ProductListingPage/pages'),
  },
  HeroVideoPopup: {
    getComponent: () => import('./components/ProductListingPage/pages'),
  },
  SignUpPage: {
    getComponent: () => import('./components/NewsLetter/SignUpPage'),
  },
  NewSizeChart: {
    getComponent: () => import('./components/NewSizeChart'),
    eventListener: 'renderSizeChart',
  },
  ProductSizeChart: {
    getComponent: () => import('./components/NewSizeChart'),
    eventListener: 'renderSizeChartToggle'
  },
  LandingPage: {
    getComponent: () => import('./components/MarketingLandingPage/pages/LandingPage'),
  },
  PDPViewMoreButtons: {
    getComponent: () => import('./components/PDPViewMoreButtons'),
  },
  FeatureCollection: {
    getComponent: () => import('./components/FeatureCollection/FeatureCollection'),
  },
  PinCodePopup: {
    getComponent: () => import('./components/NewsLetter/PinCodePopup'),
  },
  WishListPage: {
    getComponent: () => import('./components/WishList'),
  },
  WishListPopup: {
    getComponent: () => import('./components/WishList/WishListPopup'),
  },
  SplashSignUp: {
    getComponent: () => import('./components/NewsLetter/SplashSignUp')
  },
  BackInStock: {
    getComponent: () => import('./components/NewsLetter/BackInStock')
  },
  Prop65Warning: {
    getComponent: () => import('./components/Prop65Warning')
  },
  PDPBreadcrumb: {
    getComponent: () => import('./components/PDPBreadcrumb')
  },
  RecommendedProducts: {
    getComponent: () => import('./components/ProductListingPage/productList/productRecommendation/RecommendedProducts'),
    eventListener: 'renderRecommendedProducts'
  },
  LazyLoadRecommendation: {
    getComponent: () => import('./components/ProductListingPage/productList/productRecommendation/LazyLoadRecommendation'),
    eventListener: 'renderLazyLoadRecommendation'
  },
  GiveawayNudge: {
    getComponent: () => import('./components/GiveawayNudge')
  },
  NewReleasesSignUp: {
    getComponent: () => import('./components/NewsLetter/NewReleasesSignUp')
  },
  HolidayTheme: {
    getComponent: () => import('./components/HolidayTheme/HolidayTheme')
  },
  ShippingEstimator: {
    getComponent: () => import('./components/ShippingEstimator')
  },
  ScavengerHunt: {
    getComponent: () => import('./components/NewsLetter/ScavengerHunt')
  },
};
